import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { useNavigate } from "react-router-dom"

const LayoutBancoRef = ({ tipo, referencia, setTipo }) => {
  const navigate = useNavigate()
  return (
    <>
      <div
        style={{
          marginTop: "10px",
        }}
      >
        {referencia == "cype" ? (
          <div>
            <div>
              <button
                id="costPressFin"
                style={{
                  backgroundColor:
                    tipo == "Rehabilitación" ? "#FFD52B" : "#EAEAEA",
                  border: "0px",
                  marginRight: "-5px",
                  zIndex: tipo == "Rehabilitación" ? "1" : "0",
                  width: "295px",
                }}
                onClick={() => {
                  setTipo("Rehabilitación")
                }}
              >
                {i18n.t("Rehabilitación")}
              </button>
              <button
                id="costPress"
                style={{
                  backgroundColor: tipo == "Obra nueva" ? "#FFD52B" : "#EAEAEA",
                  border: "0px",
                  marginRight: "-5px",
                  zIndex: tipo == "Obra nueva" ? "1" : "0",
                  width: "295px",
                }}
                onClick={() => {
                  setTipo("Obra nueva")
                }}
              >
                {i18n.t("Obra Nueva")}
              </button>
              <button
                id="costPress"
                style={{
                  backgroundColor:
                    tipo == "Espacios urbanos" ? "#FFD52B" : "#EAEAEA",
                  border: "0px",
                  zIndex: tipo == "Espacios urbanos" ? "1" : "0",
                  marginRight: "-5px",
                  width: "295px",
                }}
                onClick={() => {
                  setTipo("Espacios urbanos")
                }}
              >
                {i18n.t("Espacios Urbanos")}
              </button>
            </div>
          </div>
        ) : referencia == "bedec" ? (
          <div>
            <div>
              <button
                id="costPressFin"
                style={{
                  backgroundColor:
                    tipo == "PARTIDAS DE OBRA Y CONJUNTOS"
                      ? "#FFD52B"
                      : "#EAEAEA",
                  border: "0px",
                  width: "fit-content",
                  marginRight: "-5px",
                  zIndex: tipo == "PARTIDAS DE OBRA Y CONJUNTOS" ? "1" : "0",
                  width: "230px",
                }}
                onClick={() => {
                  setTipo("PARTIDAS DE OBRA Y CONJUNTOS")
                }}
              >
                {i18n.t("Partidas de obra y conjuntos")}
              </button>
              <button
                id="costPress"
                style={{
                  backgroundColor: tipo == "MAQUINARIA" ? "#FFD52B" : "#EAEAEA",
                  border: "0px",
                  marginRight: "-5px",
                  zIndex: tipo == "MAQUINARIA" ? "1" : "0",
                  width: "220px",
                }}
                onClick={() => {
                  setTipo("MAQUINARIA")
                }}
              >
                {i18n.t("Maquinaria")}
              </button>
              <button
                id="costPress"
                style={{
                  width: "fit-content",
                  backgroundColor:
                    tipo == "MATERIALES Y COMPUESTOS" ? "#FFD52B" : "#EAEAEA",
                  border: "0px",
                  zIndex: tipo == "MATERIALES Y COMPUESTOS" ? "1" : "0",
                  marginRight: "-5px",
                  width: "220px",
                }}
                onClick={() => {
                  setTipo("MATERIALES Y COMPUESTOS")
                }}
              >
                {i18n.t("Materiales y compuestos")}
              </button>
              <button
                id="costPress"
                style={{
                  backgroundColor:
                    tipo == "MANO DE OBRA" ? "#FFD52B" : "#EAEAEA",
                  border: "0px",
                  zIndex: tipo == "MANO DE OBRA" ? "1" : "0",
                  marginRight: "-5px",
                  width: "220px",
                }}
                onClick={() => {
                  setTipo("MANO DE OBRA")
                }}
              >
                {i18n.t("Mano de obra")}
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </>
  )
}
LayoutBancoRef.propTypes = {
  tipo: PropTypes.string,
  referencia: PropTypes.string,
  setTipo: PropTypes.func,
}
export default LayoutBancoRef
